var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"pulse my-2",attrs:{"color":_vm.$finColors.primaryDark,"dark":"","x-small":""}},[_c('fin-lexicon-text',{attrs:{"text":"Realtime","auto-solve":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }